import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "background-container" }
const _hoisted_2 = {
  class: "background-image blur",
  ref: "background"
}
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, null, 512),
    _createElementVNode("img", {
      hidden: "",
      ref: "image",
      alt: "background image",
      src: _ctx.src
    }, null, 8, _hoisted_3)
  ]))
}